/** @jsxImportSource @emotion/react */
import * as React from 'react';
import * as styles from './ActivationDashboard.styles';

type CompletionHeaderProps = {
  completedCount: number;
  totalCount: number;
};

export function CompletionHeader({
  completedCount,
  totalCount,
}: CompletionHeaderProps): React.JSX.Element {
  const rawProgressValue =
    totalCount > 0 ? Math.round((completedCount / totalCount) * 100) : 0;
  const progressValue = Math.min(Math.max(rawProgressValue, 0), 100);

  return (
    <div css={styles.finaliseHeader}>
      <h1 className="heading1" css={styles.finaliseTitle}>
        Finalise your account
      </h1>

      <div css={styles.completionSummary}>
        <p className="body2" css={styles.completionLabel}>
          {completedCount}/{totalCount} complete
        </p>

        <span
          aria-label={`${progressValue}% complete`}
          aria-valuemax={100}
          aria-valuemin={0}
          aria-valuenow={progressValue}
          css={styles.progressRing(progressValue)}
          role="progressbar"
        />
      </div>
    </div>
  );
}
